module.exports = __webpack_public_path__ + "img/panelView_defaultBg_strong_Bg_3_3.4dcb6d11.png";